import Paragraph from '../../../scentregroup-ui/components/paragraph'
import cx from 'classnames'
import React from 'react'
import AppleButton from '../apple-login'
import GoogleButton from '../google-login'
import style from './index.scss'

type Props = {
  className?: string
  googleLogin?: () => void
  appleLogin?: () => void
}

export const SocialButtons: React.FC<Props> = (props) =>
  process.env.REACT_APP_GOOGLE_ENABLED === 'true' ||
  process.env.REACT_APP_APPLE_ENABLED === 'true' ? (
    // if neither social feature is enabled, don't render options below
    <div className={cx(style.wrapper, props.className)}>
      <Paragraph className={style.or}>or:</Paragraph>
      <div className={style.buttonContainer}>
        {process.env.REACT_APP_GOOGLE_ENABLED === 'true' && (
          <GoogleButton googleLogin={props.googleLogin}></GoogleButton>
        )}

        {process.env.REACT_APP_APPLE_ENABLED === 'true' && (
          <AppleButton appleLogin={props.appleLogin}></AppleButton>
        )}
      </div>
    </div>
  ) : null
